<div class="w-full h-full">
    <app-tab-header [tabs]="tabs">
        <span
            matTooltip="Export to Excel"
            matTooltipPosition="left"
            matTooltipClass="custom-orange-tooltip">
            <app-print-button (togglePrint)="print()"></app-print-button>
        </span>
    </app-tab-header>

    <div class="w-900-px mx-auto">
        <form [formGroup]="form">
            <!-- Row 1: Transaction ID, Transaction Type, Date From -->
            <div class="grid grid-cols-12 gap-3">
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-130-px font-semibold">Transaction ID:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            formControlName="transactionId"
                            type="text"
                            placeholder="Transaction ID">
                    </div>
                </div>
                <div class="col-span-4">
                    <app-custom-dropdown-v2
                        label="Transaction Type:"
                        [labelWidth]="'130px'"
                        [options]="transactionTypeOptions"
                        [selectedText]="transactionType_text"
                        placeholder="All"
                        (selectionChange)="setTransactionType($event.label, $event.value)">
                    </app-custom-dropdown-v2>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <app-date-input
                            class="w-full"
                            label="Date From:"
                            [parentForm]="form"
                            controlName="dateFrom">
                        </app-date-input>
                    </div>
                </div>
            </div>

            <!-- Row 2: Date To, Sender Number, Recipient Number -->
            <div class="grid grid-cols-12 gap-3 mt-3">
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <app-date-input
                            class="w-full"
                            label="Date To:"
                            [parentForm]="form"
                            controlName="dateTo">
                        </app-date-input>
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-130-px font-semibold">Sender Number:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            formControlName="senderNumber"
                            type="text"
                            placeholder="Sender Number">
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-130-px font-semibold">Recipient Number:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            formControlName="recipientNumber"
                            type="text"
                            placeholder="Recipient Number">
                    </div>
                </div>
            </div>

            <!-- Row 3: Sender First / Middle / Last Name -->
            <div class="grid grid-cols-12 gap-3 mt-3">
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-150-px font-semibold">Sender First Name:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            style="text-transform: capitalize;"
                            formControlName="senderFirstName"
                            type="text"
                            placeholder="First Name">
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-150-px font-semibold">Sender Middle Name:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            style="text-transform: capitalize;"
                            formControlName="senderMiddleName"
                            type="text"
                            placeholder="Middle Name">
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-150-px font-semibold">Sender Last Name:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            style="text-transform: capitalize;"
                            formControlName="senderLastName"
                            type="text"
                            placeholder="Last Name">
                    </div>
                </div>
            </div>

            <!-- Row 4: Recipient First / Middle / Last Name -->
            <div class="grid grid-cols-12 gap-3 mt-3">
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-150-px font-semibold">Recipient First Name:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            style="text-transform: capitalize;"
                            formControlName="recipientFirstName"
                            type="text"
                            placeholder="First Name">
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-150-px font-semibold">Recipient Middle Name:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            style="text-transform: capitalize;"
                            formControlName="recipientMiddleName"
                            type="text"
                            placeholder="Middle Name">
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-150-px font-semibold">Recipient Last Name:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            style="text-transform: capitalize;"
                            formControlName="recipientLastName"
                            type="text"
                            placeholder="Last Name">
                    </div>
                </div>
            </div>
        </form>

        <!-- Submit Button -->
        <div class="w-full flex items-center justify-center mt-10 mb-4">
            <button
                (click)="submit()"
                class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-2">
                submit
            </button>
        </div>
    </div>

    <!-- Data Table Section -->
    <div *ngIf="submitted">
        <app-table-controls
            [currentLimit]="size"
            [searchPlaceholder]="'Search'"
            (limitChangeEvent)="onLimitChangeFromComponent($event)"
            (searchKeyupEvent)="onSearchKeyupFromComponent($event)"
            (keydownEvent)="keyDownFunction($event)">
        </app-table-controls>

        <app-data-table
            [tableSubHeader]="tableSubHeader"
            [isLoading]="isLoading"
            [sort_type]="sort_type"
            (toggleOnSort)="sortList($event.key, $event.type)">
            <tr class="focus:outline-none" *ngFor="let item of itemLists">
                <td>{{ item.transactionId | nullWithDefault }}</td>
                <td>{{ item.dateTime | nullWithDefault | date:'yyyy-MM-dd HH:mm:ss' }}</td>
                <td>{{ item.senderName | nullWithDefault | titlecase }}</td>
                <td>{{ item.senderNumber | nullWithDefault }}</td>
                <td>{{ item.recipientName | nullWithDefault | titlecase }}</td>
                <td>{{ item.recipientNumber | nullWithDefault }}</td>
                <td>{{ item.transactionType | nullWithDefault }}</td>
                <td>{{ item.amount !== null ? (item.amount / 100).toFixed(2) : '0.00' }}</td>
                <td>{{ item.transferFee !== null ? (item.transferFee / 100).toFixed(2) : '0.00' }}</td>
            </tr>
        </app-data-table>

        <!-- Empty state (only shown after loading completes) -->
        <div *ngIf="!isLoading && (!itemLists || itemLists.length === 0)"
            class="bg-light-orange w-full py-3 text-gray-500"
            style="text-align: center; border-bottom: 1px solid #d1d5db;">
            <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px;">
                <img src="../../../../assets/images/icon/no-data.webp"
                    alt="No Data"
                    style="height: 48px; opacity: 0.4;"
                    onerror="this.style.display='none'">
                <span class="font-semibold text-xs uppercase tracking-wide">No records found</span>
                <span class="italic text-xs">Try adjusting your search or filter criteria.</span>
            </div>
        </div>

        <app-pagination
            backgroundColor="bg-light-orange"
            [showTotalEntries]="true"
            [currentPage]="current_page"
            [totalPages]="total_pages"
            [pageSize]="size"
            [totalItems]="total"
            (pageChange)="setPage($event)"
            (previousPage)="prevPage()"
            (nextPage)="nextPage()">
        </app-pagination>
    </div>
</div>

<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>